import { Segment, SEGMENT_PATHS, SEGMENTS } from '@sparknz/journeys-common';

export const segmentPathMap: Record<Segment, string> = {
  [SEGMENTS.PERSONAL]: '',
  [SEGMENTS.BUSINESS]: SEGMENT_PATHS.BUSINESS,
  [SEGMENTS.LARGE_BUSINESS]: SEGMENT_PATHS.LARGE_BUSINESS_AND_GOVERNMENT,
};

export const BUSINESS_SEGMENTS: Segment[] = [
  SEGMENTS.BUSINESS,
  SEGMENTS.LARGE_BUSINESS,
];

export const checkIsBusinessSegment = (segment: Segment) => {
  return BUSINESS_SEGMENTS.includes(segment);
};
